<app-steps [step]='4'></app-steps>

<!-- <div class="row page-step-title">
    <div class="col">
        <div class="jumbotron shadow-lg">
            <h1 class="header-title">Thank You!</h1>
            <h2 [innerHTML]="app.config.page4Header"></h2>
            <h2 [innerHTML]="app.config.page4SubHeader"></h2>
            <br><br>
            <a [href]="voucherUrl | safeurl" *ngIf="app.showGvDownloadLink" target="_blank" class="btn btn-blue">Download Now</a>  
            <a class="btn btn-blue" (click)="gotoVoucher()">Continue Shopping</a>
            <a class="btn btn-blue" (click)="gotoHome()">Book an Appointment</a>
        </div>
    </div>
</div> -->

<div class="row">
    <div class="col-sm-5">
        <div class="card floating shadow-lg">
            <div class="card-body">       
                <h1 class="card-title">Confirmation</h1>         
                <p >Thank you for booking online with Universal Health. A booking confirmation has been sent to your email address. If you do not receive your confirmation email, please call the clinic on <a href="tel:+61293022888">+612 9302 2888</a></p>
            </div>
            <hr>
            <div class="card-footer">
                <div class="row">
                    <div class="col-12">
                        <!-- <a class="" [href]="voucherUrl | safeurl" *ngIf="app.showGvDownloadLink" target="_blank" >
                            Download Purchased Gift Voucher</a> 
                        <br *ngIf="app.showGvDownloadLink">-->
                        <a class="" (click)="gotoVoucher()">Purchase a Gift Voucher</a><br>
                        <a class="" (click)="gotoHome()">Book Another Appointment</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-7">
        <div class="card bg-transparent">            
            <ul class="list-group list-group-flush">
                <li class="list-group-item">
                    <div class="row header">
                        <div class="col">
                            Ordered Details
                        </div>
                    </div>
                </li>
                <li class="list-group-item" *ngFor="let giftVoucher of resultItems; let i= index">
                    <div class="row">
                        <div class="col-8">
                            <span class="">
                                {{giftVoucher.description}}
                                <a class="d-none" (click)="giftVoucher.selected=!giftVoucher.selected">
                                    <i class="fas fa-info-circle"></i>
                                </a>
                            </span>
                            <span class="border-gray" value=""><br>
                                <small *ngIf="giftVoucher.invoiceDetailType==4">
                                    <b>Beneficiary:</b> {{giftVoucher.giftVoucherReceiverCollectorName}}<br>
                                    <b>Message:</b> {{giftVoucher.giftVoucherMessage}}<br>
                                    <b>Price:</b>&nbsp;<span *ngIf="app.config!=null" [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.fee | number: '1.2'}}
                                </small>
                                <small *ngIf="giftVoucher.invoiceDetailType==1">
                                    <b>Date & Time:</b> {{giftVoucher.startTime | date: 'MMM d, y - h:mm a'}}<br>
                                    <b>Staff:</b> {{giftVoucher.staffName}}<br>
                                    <b>Price:</b>&nbsp;<span [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.originalFee | number: '1.2'}}
                                    <span *ngIf="app.config!=null && giftVoucher.depositPercentage>0">
                                        <br>
                                        <b>Deposit:</b>&nbsp;<span [innerHTML]="app.config.currencySymbol"></span>{{giftVoucher.depositAmount | number: '1.2'}}
                                    </span>
                                </small>
                            </span>
                        </div>
                        <div class="col-4 text-right">
                            <a *ngIf="giftVoucher.invoiceDetailType == 4" 
                                title="Download Gift Voucher" class="" (click)="download(giftVoucher)">
                                <i class="fas fa-download fa-2x"></i>
                            </a>            
                            <div class="dropdown show" *ngIf="giftVoucher.invoiceDetailType == 1">
                                <a class="" href="#" role="button" title="Add to Calendar" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  <i class="fas fa-calendar-plus fa-2x"></i>
                                </a>                              
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                                  <a color="primary" class="addeventatc dropdown-item" data-styling="none" data-direct="apple" style="width: 100%">
                                    <img src="https://www.addevent.com/gfx/icon-apple-t5.svg" style="width: 24px;">&nbsp;Apple
                                    <span class="start">{{giftVoucher.startTime}}</span>
                                    <span class="end">{{giftVoucher.endTime}}</span>
                                    <span class="title">Universal Health</span>
                                    <span class="description">{{giftVoucher.description}}</span>
                                    <span class="location">{{app.branch.address}}</span>
                                    <span class="organizer">{{app.branch.branchName}}</span>
                                    <span class="organizer_email">{{app.branch.email}}</span>
                                    <span class="all_day_event">false</span>
                                    <span class="date_format">MM/DD/YYYY</span>
                                  </a>
                                  <a color="primary" class="addeventatc dropdown-item" data-styling="none" data-direct="google" style="width: 100%">
                                    <img src="https://www.addevent.com/gfx/icon-google-t5.svg" style="width: 24px;">&nbsp;Google
                                    <em>(online)</em>
                                    <span class="start">{{giftVoucher.startTime}}</span>
                                    <span class="end">{{giftVoucher.endTime}}</span>
                                    <span class="title">Universal Health</span>
                                    <span class="description">{{giftVoucher.description}}</span>
                                    <span class="location">{{app.branch.address}}</span>
                                    <span class="organizer">{{app.branch.branchName}}</span>
                                    <span class="organizer_email">{{app.branch.email}}</span>
                                    <span class="all_day_event">false</span>
                                    <span class="date_format">MM/DD/YYYY</span>
                                  </a>
                                  <a color="primary" class="addeventatc dropdown-item" data-styling="none" data-direct="outlook" style="width: 100%">
                                    <img src="https://www.addevent.com/gfx/icon-outlook-t5.svg" style="width: 24px;">&nbsp;Outlook
                                    <span class="start">{{giftVoucher.startTime}}</span>
                                    <span class="end">{{giftVoucher.endTime}}</span>
                                    <span class="title">Universal Health</span>
                                    <span class="description">{{giftVoucher.description}}</span>
                                    <span class="location">{{app.branch.address}}</span>
                                    <span class="organizer">{{app.branch.branchName}}</span>
                                    <span class="organizer_email">{{app.branch.email}}</span>
                                    <span class="all_day_event">false</span>
                                    <span class="date_format">MM/DD/YYYY</span>
                                  </a>
                                  <a color="primary" class="addeventatc dropdown-item" data-styling="none" data-direct="outlookcom" style="width: 100%">
                                    <img src="https://www.addevent.com/gfx/icon-outlookcom-t5.svg" style="width: 24px;">&nbsp;Outlook.com
                                    <em>(online)</em>
                                    <span class="start">{{giftVoucher.startTime}}</span>
                                    <span class="end">{{giftVoucher.endTime}}</span>
                                    <span class="title">Universal Health</span>
                                    <span class="description">{{giftVoucher.description}}</span>
                                    <span class="location">{{app.branch.address}}</span>
                                    <span class="organizer">{{app.branch.branchName}}</span>
                                    <span class="organizer_email">{{app.branch.email}}</span>
                                    <span class="all_day_event">false</span>
                                    <span class="date_format">MM/DD/YYYY</span>
                                  </a>
                                  <a color="primary" class="addeventatc dropdown-item" data-styling="none" data-direct="yahoo" style="width: 100%">
                                    <img src="https://www.addevent.com/gfx/icon-yahoo-t5.svg" style="width: 24px;">&nbsp;Yahoo
                                    <em>(online)</em>
                                    <span class="start">{{giftVoucher.startTime}}</span>
                                    <span class="end">{{giftVoucher.endTime}}</span>
                                    <span class="title">Universal Health</span>
                                    <span class="description">{{giftVoucher.description}}</span>
                                    <span class="location">{{app.branch.address}}</span>
                                    <span class="organizer">{{app.branch.branchName}}</span>
                                    <span class="organizer_email">{{app.branch.email}}</span>
                                    <span class="all_day_event">false</span>
                                    <span class="date_format">MM/DD/YYYY</span>
                                  </a>
                                </div>
                              </div>

                        </div>
                    </div>     
                </li>
            </ul>
        </div>
    </div>
</div>